import { Checkbox, HFlow } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import React from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

interface SimNaoCheckboxGroupFieldProps {
  name: MetaPath<SimNaoEnum>
}

export function SimNaoCheckboxGroupField({ name }: Readonly<SimNaoCheckboxGroupFieldProps>) {
  const { input } = useField(name.absolutePath())

  const value: SimNaoEnum | null = input.value

  const handleChange = (nextValue: SimNaoEnum) => {
    input.onChange(value === nextValue ? null : nextValue)
  }

  return (
    <HFlow hSpacing={0.5}>
      <Checkbox label='Sim' checked={value === SimNaoEnum.SIM} onChange={() => handleChange(SimNaoEnum.SIM)} />
      <Checkbox label='Não' checked={value === SimNaoEnum.NAO} onChange={() => handleChange(SimNaoEnum.NAO)} />
    </HFlow>
  )
}
